import { Injectable } from '@angular/core';
import { TranslationsProviderService } from '../translations-provider/translations-provider.service';

@Injectable({ providedIn: 'root' })
export class TemplateAssemblyService {

  constructor(private translationsService: TranslationsProviderService) {}

  assembleRouteTemplate(
    outerMasterPage: any,
    innerMasterPage: any,
    formContent: any,
    wgRoute: { PrettyUrl: string; SerializationObjectFormLink: string; Title: string },
    masterPageLoaded: boolean
  ): string {
    let template: string = outerMasterPage;

    if (masterPageLoaded) {
      let formName: string = wgRoute.Title;
      template = template.replace('<*--formTemplatePlaceholder-->', innerMasterPage);
      template = template.replace('<*--formInnerTemplatePlaceholder-->', formContent);
      template = template.replace('addNewLink', wgRoute.PrettyUrl);
      template = template.replace('<*--sofm-->', wgRoute.SerializationObjectFormLink);

      let trans = null;
      if (typeof this?.translationsService?.translations != 'undefined' && this?.translationsService?.translations) {
        if (typeof this?.translationsService?.translations[formName] != 'undefined' && typeof this?.translationsService?.translations[formName]) {
          trans = typeof this?.translationsService?.translations[formName];
        }
      }

      if (trans) {
        template = template.replace('<*--pageName-->', this.translationsService?.translations[formName].toUpperCase());
      }
    } else {
      template = template.replace('<app-root></app-root>', formContent);
    }

    return template;
  }
}
